import React, { useState, useEffect } from "react";
import SetupScreen from "./screens/SetupScreen";
import FamilyMemoriesScreen from "./screens/FamilyMemoriesScreen";
import SlideshowScreen from "./screens/SlideshowScreen";
import { initRos, onTemiStateChange } from "./rosbridge_client";
import AuthGate from "./AuthGate";

function App() {
  // const [screen, setScreen] = useState("setup");
  const [screen, setScreen] = useState("family-memories");
  const [backendUrl, setBackendUrl] = useState("");
  const [viewMode, setViewMode] = useState("carousel");
  const [memories, setMemories] = useState([]);

  // ✅ STATI AUTENTICAZIONE (mancavano → errore eslint)
  const [authChecked, setAuthChecked] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);


  // 1) Load config

  useEffect(() => {
    async function loadConfig() {
      try {
        // const res = await fetch("/config.json");
        // const res = await fetch("family-memories/config.json");
        const slug = window.location.pathname
          .split("/")
          .filter(Boolean)[0];
        const res = await fetch(`/${slug}/config.json`);
        const cfg = await res.json();
        setBackendUrl(cfg.backend_url);
        console.log("✅ Config loaded:", cfg);
      } catch (err) {
        console.error("❌ Failed to load config.json:", err);
      }
    }
    loadConfig();
  }, []);


  // 2) Verifica sessione UNA SOLA VOLTA

  useEffect(() => {
    async function checkAuth() {
      try {
        const res = await fetch("/api/auth/me", { credentials: "include" });
        // const res = await fetch("family-memories/api/auth/me", { credentials: "include" });
        const data = await res.json();
        setIsAuthenticated(data.authenticated === true);
      } catch (err) {
        setIsAuthenticated(false);
      } finally {
        setAuthChecked(true);
      }
    }

    checkAuth();
  }, []);


  // 3) Attesa controllo auth

  if (!authChecked) {
    return <div>Cargamento...</div>;
  }


  // 4) Non autenticato → mostra AuthGate
  if (!isAuthenticated) {
    return (
      <AuthGate
        backendUrl={backendUrl}
        onAuthenticated={() => {
          setIsAuthenticated(true);
          window.history.replaceState({}, "", "/");
        }}
      />
    );
  }

  // 5) UI principale (login MAI più mostrato)

  switch (screen) {
    case "setup":
      return <SetupScreen onNext={() => setScreen("family-memories")} />;

    case "family-memories":
      return (
        <FamilyMemoriesScreen
          backendUrl={backendUrl}
          setViewMode={setViewMode}
          startSlideshow={(photos) => {
            setMemories(photos);
            setScreen("slideshow");
          }}
          onBackToSetup={() => setScreen("setup")}
        />
      );

    case "slideshow":
      return (
        <SlideshowScreen
          backendUrl={backendUrl}
          memories={memories}
          viewMode={viewMode}
          onBack={() => setScreen("family-memories")}
        />
      );

    default:
      return <p>Unknown screen</p>;
  }
}

export default App;




